import { ChangeEvent, FC, MouseEventHandler } from 'react';
import {
  InputText as PrimeInputText,
  InputTextProps as PrimeInputTextProps,
} from 'primereact/inputtext';

/**
 * Props for CloudFoundryFilter component
 */
interface CloudFoundryFilterProps extends Omit<
  PrimeInputTextProps,
  'onChange'
> {
  /** Handler for clearing the filter input */
  onClear: MouseEventHandler<HTMLButtonElement>;
  /** Handler for input change events */
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  /** Current filter value */
  value: string;
}

/**
 * Filter input component for Cloud Foundry applications table
 * Provides a search input with clear functionality
 *
 * @param props - Component props
 * @returns Filter input component
 */
export const CloudFoundryFilter: FC<CloudFoundryFilterProps> = ({
  onClear,
  onChange,
  value,
  ...props
}) => {
  return (
    <div style={{ position: 'relative', width: '40%' }}>
      <PrimeInputText
        {...props}
        value={value}
        onChange={onChange}
        style={{
          ...props.style,
          paddingRight: '32px',
          width: '100%',
        }}
      />
      {value && (
        <button
          onClick={onClear}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
          title="Clear filter"
          aria-label="Clear filter"
        >
          ✕
        </button>
      )}
    </div>
  );
};
